require('/ui/components/link/link.module.scss.module.css');

export const link = "_link_7qdyl_1";
export const linkAsButton = "_linkAsButton_7qdyl_1";
export const linkDarkMode = "_linkDarkMode_7qdyl_1";
export const smallViewportSupport = "_small-viewport-support_7qdyl_1";
export const linkAsManaButton = "_linkAsManaButton_7qdyl_1";
export const linkDefault = "_linkDefault_7qdyl_1";
export const linkPrimary = "_linkPrimary_7qdyl_1";
export const linkManaDefault = "_linkManaDefault_7qdyl_1";
export const linkWarning = "_linkWarning_7qdyl_1";
export const linkSmall = "_linkSmall_7qdyl_1";
export const linkFullWidth = "_linkFullWidth_7qdyl_1";
export const iconContainer = "_icon-container_7qdyl_1";
